import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CategoriesEdit from "../../../../components/_utils/AccountCreationComponents/CategoriesEdit";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import {
  editFieldForceAccount,
  getSpecificFieldForceAccount,
  resetEditFieldForceAccount,
} from "../../../../redux/features/accounts/fieldForceAccount";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import ICONS from "../../../../assets/Icons";

const FieldForceEditCategories = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const sliceCategory = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
    editFieldForceAccountData,
  } = useSelector((state) => state.fieldForceAccount);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sliceCategories, setSliceCategories] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [buttondisable, setButtondisable] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);
  const [initialCategories, setInitialCategories] = useState([]);
  const [cancelBut, setCanclebtn] = useState(false);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        const response1 = await dispatch(getSpecificFieldForceAccount({ id }));
        if (
          response1?.error?.message === "Request failed with status code 404"
        ) {
          navigate("*");
          return;
        }

        const response2 = await dispatch(getAllCategories());
        if (
          response2?.error?.message === "Request failed with status code 404"
        ) {
          navigate("*");
          return;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCategoryData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    setSliceCategories(
      (sliceCategory || []).filter((category) => category?.active === "Y"),
    );
  }, [sliceCategory]);

  useEffect(() => {
    if (
      getSpecificFieldForceAccountLoading ||
      getSpecificFieldForceAccountData?.status !== true ||
      sliceCategories.length === GlobalConfiguration.lengthCheckZero
    ) {
      return;
    }

    const fieldForceData =
      getSpecificFieldForceAccountData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    const assignedIds = (fieldForceData?.category_ids || []).map((c) =>
      String(c?.category_id ?? c?.id ?? c),
    );

    const hasAllAccess = assignedIds.length === 0;

    const selectedCategoriesArray = hasAllAccess
      ? sliceCategories.map((cat) => cat.id)
      : sliceCategories
          .filter((cat) => assignedIds.includes(String(cat.id)))
          .map((cat) => cat.id);

    setSelectedCategories(selectedCategoriesArray);
    setInitialCategories(selectedCategoriesArray);
  }, [
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
    sliceCategories,
  ]);

  useEffect(() => {
    const sameAsInitial =
      selectedCategories.length === initialCategories.length &&
      selectedCategories.every((cat) => initialCategories.includes(cat));

    setIsUpdateDisabled(sameAsInitial);

    setSelectAllChecked(
      sliceCategories.length > GlobalConfiguration.lengthCheckZero &&
        selectedCategories.length === sliceCategories.length,
    );
  }, [selectedCategories, sliceCategories, initialCategories]);

  const handleBack = () => {
    if (!isUpdateDisabled) {
      setOpenPopEdit(true);
    } else {
      navigate(-1);
    }
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      nextHoverOption: "black",
      previousEnableBgColor: "var(--primary-nav-act)",

      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: !cancelBut && "var(--text-disabled)",
      nextIsEnabled:
        !isUpdateDisabled &&
        !buttondisable &&
        !updateActive &&
        !getSpecificFieldForceAccountLoading,
      stepperText: "Category",
      nextIsLoading: cancelBut ? true : false,
      nextLoaderNeeded: true,
    },
  ];

  useEffect(() => {
    if (editFieldForceAccountData?.status === true) {
      const updatedCategoryNames = sliceCategories
        .filter((category) =>
          selectedCategories.some(
            (selectedCategoryId) =>
              String(selectedCategoryId) === String(category.id),
          ),
        )
        .map((category) => category.category_name || category.name)
        .filter(Boolean);

      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories_success/${id}`,
        {
          state: {
            updatedFields: ["category"],
            updatedCategoryNames,
          },
        },
      );
      dispatch(resetEditFieldForceAccount());
    }
  }, [
    dispatch,
    editFieldForceAccountData,
    id,
    navigate,
    selectedCategories,
    sliceCategories,
  ]);

  const handleUpdateAccount1 = async () => {
    if (updateActive) return;
    const willShowUnsafePopup =
      (selectedCategories?.length === sliceCategories.length &&
        !showAlertCategories) ||
      (!selectedCategories?.length && !showAlertCategories);

    if (willShowUnsafePopup) {
      setShowAlertCategories(true);
    } else {
      setCanclebtn(true);
      setUpdateActive(true);
      const fieldForceAccount =
        getSpecificFieldForceAccountData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      const linkedUserId =
        fieldForceAccount?.field_force_user_id ||
        fieldForceAccount?.linked_user_id ||
        null;
      const selectedCategoryIds = sliceCategories
        .filter((category) =>
          selectedCategories.some(
            (selectedCategoryId) =>
              String(selectedCategoryId) === String(category.id),
          ),
        )
        .map((category) => category.id);

      const response = await dispatch(
        editFieldForceAccount({
          id: id,
          category_ids: selectedCategoryIds,
          linked_user_id: linkedUserId,
          navigate,
        }),
      );

      if (response?.error?.message === "Rejected") {
        setButtondisable(false);
        setUpdateActive(false);
      } else {
        setButtondisable(true);
      }
      setShowAlertCategories(false);
      setCanclebtn(false);
    }
  };

  const toggleSelectAll = () => {
    if (selectedCategories.length === sliceCategories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(sliceCategories.map((cat) => cat.id));
    }
  };

  const handleCategorySelect = (categoryId) => {
    const category = sliceCategories.find(
      (c) => String(c.id) === String(categoryId),
    );
    if (!category) return;

    const isSelected = selectedCategories.some(
      (selectedCategoryId) =>
        String(selectedCategoryId) === String(category.id),
    );
    const updated = isSelected
      ? selectedCategories.filter(
          (selectedCategoryId) =>
            String(selectedCategoryId) !== String(category.id),
        )
      : [...selectedCategories, category.id];

    setSelectedCategories(updated);
  };

  const handleConfirm = () => {
    navigate(-1);
  };

  const sortedCategories = sliceCategories;

  return (
    <div className="edit-1024-con bg-primary-bg">
      <div
        className="edit-category-main"
        style={{
          overflowY: showAlertCategories ? "hidden" : "scroll",
          scrollbarWidth: "none",
        }}
      >
        {showAlertCategories && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopupWithBulletPoints
              headerTitle={"Unsafe to proceed"}
              bulletPoints={[
                "All categories will be linked to a single account.",
                "It is recommended to distribute categories across appropriate accounts.",
              ]}
              headerFontWeight="semibold"
              headerFontColor="negative-act"
              textSize="font-md"
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => {
                setShowAlertCategories(false);
                setUpdateActive(false);
                setCanclebtn(false);
              }}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Proceed"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleUpdateAccount1}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {openPopEdit && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Leaving this page will not update the changes made."
              btnOneText="Stay"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => setOpenPopEdit(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleConfirm}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div className="main_edit_category_stepper_div Qmd:relative">
          <PrimaryStepper
            activeStep={0}
            handleForwardAction={handleUpdateAccount1}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
        <div className="w-width-full relative edit-cate-top-bottom-div">
          <div className="bg-primary-nav fixed top-top-base w-width-full flex z-z-index-modal shadow-box-shadow-bottom">
            <div
              className="w-icon-md h-icon-md m-margin-md"
              onClick={() => handleBack()}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color="var(--text-primary)"
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
              />
            </div>
            <div className="py-padding-sm">
              <p className="text-text-primary text-font-md">
                Field force account
              </p>
              <p className="text-text-secondary text-font-xs">
                Edit categories
              </p>
            </div>
          </div>
          <div
            className={`h-mobile-create-header ${
              !isUpdateDisabled && !buttondisable && !updateActive
                ? "bg-positive-act cursor-pointer"
                : "bg-text-disabled cursor-not-allowed"
            } fixed bottom-bottom-base w-width-full text-text-primary items-center justify-center flex font-semibold z-z-index-modal`}
            onClick={
              !isUpdateDisabled && !buttondisable && !updateActive
                ? handleUpdateAccount1
                : undefined
            }
          >
            Update
          </div>
        </div>
        <div className="dividecategory-edit-flow">
          <div className="w-width-full Qlg:w-width-md">
            <div className="flex flex-col Qsmd:pt-padding-md">
              <div className="mt-margin-lg Qmd:mt-margin-base rounded-border-radius-md">
                <CategoriesEdit
                  sortedCategories={sortedCategories}
                  selectedCategories={selectedCategories}
                  setSelectedCategories={setSelectedCategories}
                  selectAllChecked={selectAllChecked}
                  toggleSelectAll={toggleSelectAll}
                  handleCategorySelect={handleCategorySelect}
                  Title={"Assign Categories"}
                  SubTitle="Not selecting categories will assign all, including future ones, to this account. This is not recommended for security reasons."
                  TitleFontcolor="text-primary"
                  TextSize="font-md"
                  SubTitleFontcolor="text-secondary"
                  SubTitleTextSize="font-xs"
                  TitleFontWeight="semibold"
                  SubTitleFontWeight="normal"
                  isCategoryLoading={getSpecificFieldForceAccountLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldForceEditCategories;
